<template>
    <div class="af-apply-complete-container">
        <div class="af-apply-content afu-flex afu-flex-col afu-items-center">
            <FontAwesomeIcon
                :icon="['fas', 'check-circle']"
                class="afu-mr-2 afu-text-success-400"
                size="3x"
            />
            <p class="af-apply-tks-title afu-font-semibold afu-mt-4">
                {{ $t('apply.success') }}
            </p>
            <p class="af-apply-tks-text afu-text-gray-600 afu-text-center">
                {{ $t('apply.confirmation') }}
                <br>
                <span class="af-apply-email afu-text-primary-400">
                    {{ $_applyEmail() }}
                </span>
            </p>
            <C1Button 
                v-if="!$_job.screening_question_set"
                type="button"
                variant="primary"
                size="lg"
                @click.stop.prevent="goBackToJobView()"
            >
                {{ $t('apply.back') }}
            </C1Button>
        </div>
        <ScreeningQuestion 
            v-if="showScreeningQuestion"
            :job-uuid="$_job.uuid"
            :job-url="getJobUrl()"
        />
    </div>
</template>

<script>
    import { mapState, mapMutations, mapGetters } from 'vuex';
    import {getJobViewLink, slugify} from '@/utils/helpers';
    import C1Button from '@/components/C1Components/C1Button';
    import ScreeningQuestion from './ScreeningQuestion';

    export default {
        name: 'ApplyComplete',

        components: {
            C1Button,
            ScreeningQuestion,
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),

            showScreeningQuestion() {
                return window?.afConfig?.screening_question_position?.toLowerCase() === 'after job apply';
            },
        },

        methods: {

            ...mapMutations('jobApplication', {
                $_RESET_APPLY: 'RESET_APPLY',
            }),

            ...mapGetters('jobApplication', {
                $_applyEmail: 'applyEmail',
            }),

            goBackToJobView() {
                this.$_RESET_APPLY();
                const applyURL = getJobViewLink(`${slugify(this.$_job.job_title)}/${this.$_job.uuid}`);
                window.location.href = applyURL;
            },

            getJobUrl() {
                return getJobViewLink(`${slugify(this.$_job.job_title)}/${this.$_job.uuid}`);
            },
        },
    };
</script>
